import { selectUserProject } from 'core/userContext/selectors';
import { useEffect, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { changeUserProjectRequest } from 'api/UserAPI';
import { PublishedJourneyContextProvider } from 'modules/workflowNodeEditors/components/StartNodeEditor/EntranceLimitForm/ConcurrentJourneyEntranceCriteriaUtils/PublishedJourneysContext';
import { Workflow as WorkflowComponent } from './components/Workflow';
import { WorkflowContextProvider } from './context/WorkflowContext';
import { TriggerJourneyContextProvider } from './context/TriggerJourneyContext';
import { ExitRuleContextProvider } from './context/ExitRuleContext';
import { JourneyReviewContextProvider } from './context/JourneyReviewContext';
import { JourneyAssistContextProvider } from './context/JourneyAssistContext';
import { FieldMappingsContextProvider } from './context/FieldMappingsContext';

import {
  getIsJourneyReviewPanelEnabled,
  getIsJourneyFieldMappingsEnabled,
} from './ducks/selectors';
import { JourneyVisitorTrackingContextProvider } from './context/JourneyVisitorTrackingContext';

export const Workflow = (props) => {
  const currentProject = useSelector(selectUserProject);
  const isJourneyReviewPanelEnabled = useSelector(getIsJourneyReviewPanelEnabled);
  const isJourneyFieldMappingsEnabled = useSelector(getIsJourneyFieldMappingsEnabled);

  useEffect(() => {
    const handleOnTabFocus = () => {
      changeUserProjectRequest(currentProject.id);
    };
    window.addEventListener('focus', handleOnTabFocus);
    // eslint-disable-next-line consistent-return
    return () => window.removeEventListener('focus', handleOnTabFocus);
  }, []);

  const JourneyReviewContextProviderCmp = isJourneyReviewPanelEnabled
    ? JourneyReviewContextProvider
    : Fragment;

  const FieldMappingsContextProviderCmp = isJourneyFieldMappingsEnabled
    ? FieldMappingsContextProvider
    : Fragment;

  return (
    <WorkflowContextProvider {...props}>
      <JourneyVisitorTrackingContextProvider>
        <FieldMappingsContextProviderCmp>
          <JourneyReviewContextProviderCmp>
            <ExitRuleContextProvider>
              <JourneyAssistContextProvider>
                <TriggerJourneyContextProvider>
                  <PublishedJourneyContextProvider>
                    <WorkflowComponent />
                  </PublishedJourneyContextProvider>
                </TriggerJourneyContextProvider>
              </JourneyAssistContextProvider>
            </ExitRuleContextProvider>
          </JourneyReviewContextProviderCmp>
        </FieldMappingsContextProviderCmp>
      </JourneyVisitorTrackingContextProvider>
    </WorkflowContextProvider>
  );
};
